import React, { useEffect, useState } from "react";
import ReactPaginate from 'react-paginate';
import { Form, Table } from 'react-bootstrap';
import "./tableDetails.css";

function ItemsDetails({ currentItems, paginationNumber }) {
    return (
        <>
        {currentItems &&
            currentItems.map((elem, i)=>{
                return (
                    <tr key={i} className='centerData'>
                        <td>{(i + 1) + (paginationNumber)}</td>
                        <td>{elem.codVar}</td>
                        <td>{elem.descripcion}</td>
                        <td>{elem.peso_vc}</td>
                        <td>{elem.peso_ter}</td>
                        <td>{elem.peso_vf}</td>
                        <td>{elem.fecha_vc}</td>
                        <td>{elem.fecha_vf}</td>
                        <td>{elem.idDespacho}</td>
                        <td>{elem.nombre}</td>
                    </tr>
                )
            })
        }
        </>
    );
}
export default ItemsDetails


export function PaginatedItemsDetails({ data }) {
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    
    const [itemsPerPage, setItemsPerPage] = useState(10)
    
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        setItemOffset(newOffset);
    };

    const handleChange = (event) =>{
        setItemsPerPage(Number(event.target.value));
    }
    
    return (
        <>
        <div className='gridData'>
            <Table striped bordered hover variant >
                <thead>
                    <tr>
                    <th>#</th>
                    <th>Codigo Vara</th>
                    <th>Descripción</th>
                    <th>Peso VC</th>
                    <th>Peso TER</th>
                    <th>Peso VF</th>
                    <th>Fecha VC</th>
                    <th>Fecha VF</th>
                    <th>Despacho</th>
                    <th>Cliente</th>
                    </tr>
                </thead>
                <tbody>
                    <ItemsDetails currentItems={currentItems} paginationNumber={itemOffset}></ItemsDetails>
                </tbody>
            </Table>
            <div className='navigation'>
                <ReactPaginate
                    nextLabel="siguiente >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="< anterior"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination justify-content-center"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                />
                <Form.Select className='formSelect' defaultValue="10" onChange={handleChange}>
                    <option>10</option>
                    <option>20</option>
                    <option>30</option>
                    <option>40</option>
                    <option>50</option>
                </Form.Select>
            </div>
        </div>
        </>
    );
}

